﻿import TechnoDialog from "./custom.dialog.js"
import TechnoLinkTile from "./te.link.tile.js"

const customElementList = [
    { name: 'techno-dialog', class: TechnoDialog},
    { name: 'techno-link-tile', class: TechnoLinkTile}
]

customElementList.forEach(element => {
    !customElements.get(element.name) && customElements.define(element.name, element.class)
})